import { useQuery } from "react-query";

const getApplicationData = (id = null, isReapply = false) => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  const userInfo = Digit.UserService.getUser();

  if (id) {
    //edit workflow
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPAREGSearch(tenantId, {}, { applicationNumber: id });
    };
    const { data, isLoading: isAppDataLoading, isSuccess } = useQuery({ queryKey: [id], queryFn: fetchApplicationData });

    const applicationData = isSuccess && data?.Licenses?.[0];
    return { applicationData, isAppDataLoading };
  }
  // else if (isReapply) {//reapply workflow
  //     const fetchApplicationData = async () => {
  //         return await Digit.OBPSService.BPAREGSearch(tenantId, {}, { mobileNumber: userInfo?.info?.mobileNumber })
  //     }
  //     const { data, isLoading: isAppDataLoading, isSuccess } = useQuery({ queryKey: [id], queryFn: fetchApplicationData });
  //     console.log(data, "dataattatta");

  //     const applicationData = isSuccess && data?.Licenses?.[0];
  //     console.log(applicationData, "applicationDatata");

  //     return { applicationData, isAppDataLoading }
  // }
  // Create Application data object for create flow
  const businessService = "BPAREG";

  const applicationData = {
    tenantId,
    action: "INITIATE",
    licenseType: "PERMANENT",
    applicationType: "NEW",
    businessService: businessService,
    idProofType: null,
    registrationNo: null,
    validupto: null,
    authorityName: null,
    tradeLicenseDetail: {
      owners: [
        {
          gender: null,
          mobileNumber: userInfo?.info?.mobileNumber,
          name: userInfo?.info?.name,
          dob: null,
          emailId: null,
          initialForApplicantName: userInfo?.info?.initialForApplicantName,
          permanentAddress: null,
          correspondenceAddress: null,
          pan: null,
          qualification: null,
          totalExperience: null,
          firmName: null,
          profileSummary: null,
          aadhaarNumber: null,
          nationality: null,
          architectureNo: null,
        },
      ],
      subOwnerShipCategory: "INDIVIDUAL",
      tradeUnits: [
        {
          tradeType: null,
        },
      ],
      additionalDetail: {
        counsilForArchNo: null,
      },
      address: {
        city: "",
        landmark: "",
        pincode: "",
      },
      institution: null,
      applicationDocuments: null,
    },
  };
  return { applicationData, isAppDataLoading: false };
};

export default getApplicationData;
